import { connect } from 'react-redux';
import { selectDisplayBrackets } from '@selectors/bracketView';
import { Bracket as BracketType } from '@models/Match';
import BracketGrid from './BracketGrid';

export const mapStateToProps = (state) => {
  const brackets = selectDisplayBrackets(state);

  return {
    forward: brackets[BracketType.Forward],
    reverse: brackets[BracketType.Reverse],
    final: brackets[BracketType.Final],
  };
};

export default connect(mapStateToProps)(BracketGrid);
